import { render } from "./AdminConversationStarters.vue?vue&type=template&id=3bd04ba2&scoped=true"
import script from "./AdminConversationStarters.vue?vue&type=script&lang=js"
export * from "./AdminConversationStarters.vue?vue&type=script&lang=js"

import "./AdminConversationStarters.vue?vue&type=style&index=0&id=3bd04ba2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd04ba2"]])

export default __exports__